import React from "react";

import ToggleSwitch from "@src/assets/svg/components/ToggleSwitch";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Switch.module.css";

interface IncomingProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
  on: boolean;
  disabled?: boolean;
  className?: string;
}

export default function Switch(props: IncomingProps) {
  return (
    <div
      onClick={props.disabled ? undefined : props.onClick}
      className={toClassName(
        props.disabled ? styles.disabled : styles.enabled,
        props.className
      )}
    >
      <ToggleSwitch on={props.on} className={styles.switchSvg} />
    </div>
  );
}
